import { Button, Modal } from 'antd';
import React from 'react';

const CommonBulkDeleteModal = ({
  showModal = false,
  setShowModal,
  selectedCount = 0,
  onConfirm,
  loading = false,
  entityName = 'item',
  entityNamePlural = 'items',
  title,
}) => {
  const handleCancel = () => {
    setShowModal(false);
  };

  const handleOk = () => {
    onConfirm?.();
    handleCancel();
  };

  const entityText = selectedCount === 1 ? entityName : entityNamePlural;

  const getModalTitle = () => {
    if (title) {
      return title;
    }
    const capitalizedText =
      entityText?.charAt(0)?.toUpperCase() + entityText?.slice(1);
    return `Delete ${selectedCount} ${capitalizedText}`;
  };

  const getModalMessage = () => {
    const capitalizedText =
      entityText?.charAt(0)?.toUpperCase() + entityText?.slice(1);
    return `${capitalizedText} will be permanently deleted and will not be available.`;
  };

  return (
    <Modal
      maskClosable={false}
      centered
      closable={false}
      footer={null}
      open={showModal}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <h2>{getModalTitle()}</h2>
      <p>{getModalMessage()}</p>
      <div className="form-buttons">
        <Button
          shape="round"
          className="cancel-button"
          onClick={handleCancel}
          disabled={loading}
        >
          No, Cancel
        </Button>
        <Button
          shape="round"
          type="primary"
          className="delete-button"
          onClick={handleOk}
          loading={loading}
        >
          Yes, Delete
        </Button>
      </div>
    </Modal>
  );
};

export default CommonBulkDeleteModal;
